import { PageHeader } from "antd"
import { MenuUnfoldOutlined } from "@ant-design/icons"
import UserHeader from "./user-header"
import { PageContext } from "../../../contexts"
import { useContext } from "react"

function Toolbar({ subheader }) {
  const { title, actions, currentStepKey, stepsToOmit } = useContext(PageContext)

  subheader = typeof subheader === "function" ?
    subheader({ title, actions, currentStepKey, stepsToOmit }) :
    subheader

  if (subheader !== false){
    subheader = subheader || <PageHeader title={title} extra={actions} />
  }

  return (
    <div>
      <PageHeader
        title={(title && !subheader) && title}
        backIcon={<MenuUnfoldOutlined />}
        extra={<UserHeader />}>
        {subheader}
      </PageHeader>
    </div>
  )
}

export { Toolbar }
